import { Modal, Title } from '@lessonnine/design-system.lib'
import { getColoursFromTheme, Stack, Text } from 'src/viewLayer/components/DesignSystem/index.js'
import devices from 'src/viewLayer/styling/mixins/mediaQueries.js'
import styled from 'styled-components'

const Container = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    max-width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    max-width: 21rem;
  }
`

const Separator = styled.hr`
  border: 0;
  color: ${({ theme }) => getColoursFromTheme(theme).authContainer.textColor};
  height: 1.5em;
  line-height: 1em;
  position: relative;
  outline: 0;
  text-align: center;
  width: 100%;
  &:before {
    content: '';
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.textColor};
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
    color: ${({ theme }) => getColoursFromTheme(theme).authContainer.textColor};
    content: attr(data-content);
    display: inline-block;
    line-height: 1.5em;
    padding: 0 0.5em;
    position: relative;
  }
`

const SeparatorText = styled(Text)`
  width: 100%;
`

const ModalContainer = styled(Modal)`
  width: 30rem;
  @media only screen and ${devices.fromsmall} {
    width: 40rem;
  }
`

const ModalTitle = styled(Title)`
  border: 0;
  color: ${({ theme }) => getColoursFromTheme(theme).brandColor};
`

export { Container, ModalContainer, ModalTitle, Separator, SeparatorText }
